import React from "react";
import { ConnectorStatusContainer } from "../../container/panelReports";

const ConnectorStatusScreen: React.FC<{}> = () => {
  return <ConnectorStatusContainer/>;
}

export default ConnectorStatusScreen;